(function () {
    'use strict';

    angular
        .module('core.services')
        .service('EconomicGroupService', EconomicGroupService)

    /** @ngInject */
    function EconomicGroupService(HttpService) {
        const EconomicGroupService = {
            get: get,
            getAll: getAll,
            getByParameters: getByParameters,
            post: post,
            put: put,
            putList: putList,
            deleteGroup: deleteGroup
        }

        return EconomicGroupService;

        function get(groupId) {
            return HttpService.get(`/economic-groups/${groupId}`);
        }

        function getAll() {
            return HttpService.get('/economic-groups/all');
        }

        function getByParameters(params) {
            return HttpService.get('/economic-groups', {
                params
            });
        }

        function post(groupData) {
            return HttpService.post('/economic-groups', groupData);
        }

        function put(groupData) {
            return HttpService.put('/economic-groups', groupData);
        }

        function putList(groupListData) {
            return HttpService.put('/economic-groups/cluster-performance', groupListData);
        }

        function deleteGroup(groupId) {
            return HttpService.delete(`/economic-groups/${groupId}`);
        }
    }
}());